module.exports = __webpack_public_path__ + "img/sleet.2fb7ecb7.svg";